import React, { useEffect, useState } from "react";
import HomeView from "./HomeView";
import crmservices from '../../wsclient';
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";

export default function HomeController(props) {
	//get value from index.html
	const order_queue_name = document._portalConfig.order_queue_name;
	const order_stage_installation = document._portalConfig.order_stage_installation;
	const order_stage_installation_complete = document._portalConfig.order_stage_installation_complete;
	const activity_types = document._portalConfig.activity_types;
	//
	const [message, setMessage] = useState();
	const [showConfirm, setShowConfirm] = useState();
	const [showProcessing, setShowProcessing] = useState(false);
	const [fullName, setFullName] = useState(null);
	const [queueId, setQueueId] = useState(null);
	const [stageId, setStageId] = useState(null);
	const [stageCompletedId, setStageCompletedId] = useState(null);
	const [isReloadCompletedList, setIsReloadCompletedList] = useState(false);

	const [activityTypes, setActivityTypes] = useState({
		installation: null,
		uninstallation: null,
		swapping: null,
		reinstallation: null,
		serviceVisit: null
	});
	const [showLoadingTotal, setShowLoadingTotal] = useState({
		waitingAdd: true,
		total_activities: true,
	});
	const [total, setTotal] = useState({
		waitingAdd: 0,
		total_activities: 0
	});

	useEffect(() => {
		onLoadListQueue();
		const sessionData = crmservices.getSession();
		if (sessionData && sessionData.full_name) {
			setFullName(sessionData.full_name)
		}
		onLoadActivityTypes('installation', activity_types.installation_activity_name);
	}, []);

	useEffect(() => {
		if (queueId)
			onLoadQueue()
	}, [queueId]);

	useEffect(() => {
		if (stageId)
			onLoadListActivities()
	}, [stageId]);

	useEffect(() => {
		if (stageCompletedId)
			onLoadListWaitingAddDevice()
	}, [stageCompletedId]);

	const onLoadListQueue = async () => {
		let data = [];
		try {
			var result = await crmservices.orders.getListQueue({ search_value: order_queue_name });
			if (result.code === 'OK') {
				console.log("result:", result);
				data = result.data.content ? result.data.content : [];
				if (data.length > 0)
					setQueueId(data[0].id);
			}
		} catch (error) {
			console.log("on Load ListQueue error:", error);
		}
	}

	const onLoadQueue = async () => {
		let stages = [];
		try {
			var result = await crmservices.orders.getQueue(queueId);
			if (result.code === 'OK') {
				console.log("result:", result);
				stages = result.data.stages ? result.data.stages : [];
				stages.map(element => {
					if (element.name === order_stage_installation) {
						setStageId(element.id)
					}
					if (element.name === order_stage_installation_complete) {
						setStageCompletedId(element.id)
					}
				})
			}

		} catch (error) {
			console.log("on Load Queue error:", error);
		}
	}

	const onLoadListActivities = async () => {
		let total = 0;
		try {
			const result = await crmservices.activities.getActivities({
                page: 1,
                size: 1,
                state: "PENDING",
                include_total: true
            });
			if (result.code === 'OK') {
				total = result.data.paging ? result.data.paging.total : 0;
			}
		} catch (error) {
			console.log("load installations error:", error);
		}
		setTotal(prevState => ({
			...prevState,
			['total_activities']: total
		}));
		setShowLoadingTotal(prevState => ({
			...prevState,
			['total_activities']: false
		}));
	}

	const onLoadListWaitingAddDevice = async () => {
		let total = 0;
		try {
			let myUserId = httpBackOfficeUtil.getSession().sub;
			var result = await crmservices.orders.getListInstallation({
				page: 1,
				size: 1,
				stage_id: stageCompletedId,
				custom_fields: `assigned_to;${myUserId};enable_devices;0`,
				include_total: true,
			});
			console.log("AAAAAAAAAAAAA onLoadListActivities:", result);

			if (result.code === 'OK') {
				total = result.data.paging ? result.data.paging.total : 0;
			}
		} catch (error) {
			console.log("load installations error:", error);
		}
		setTotal(prevState => ({
			...prevState,
			['waitingAdd']: total
		}));
		setShowLoadingTotal(prevState => ({
			...prevState,
			['waitingAdd']: false
		}));
	}

	const onLoadListActivity = async (type) => {
		let total = 0;
		try {
			const result = await crmservices.activities.getActivities({
				type_id: activityTypes[type],
				page: 1,
				size: 1,
				state: "PENDING",
				include_total: true
			});
			if (result.code == 'OK') {
				total = result.data.paging && result.data.paging.total ? result.data.paging.total : 0;
			}
		} catch (ex) {

		}
		setTotal(prevState => ({
			...prevState,
			[type]: total
		}));
		setShowLoadingTotal(prevState => ({
			...prevState,
			[type]: false
		}));
	}

	const onLoadActivityTypes = async (key, name) => {
		try {
			const result = await crmservices.activities.getActivitiesType({ search_value: name });
			console.log("AAAAA onLoadActivityTypes:", result);
			if (result.code == 'OK') {
				let data = result.data.content ? result.data.content : [];
				if (data.length > 0) {
					setActivityTypes(prevState => ({
						...prevState,
						[key]: data[0].id
					}));
				}
				else
					setShowLoadingTotal(prevState => ({
						...prevState,
						[key]: false
					}));
			}
		} catch (ex) {
			console.log("onLoadActivityTypes:", onLoadActivityTypes);
		}
	}

	const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
		setShowProcessing(false);
		setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
	}

	const onReloadInstallationList = () => {
		setIsReloadCompletedList(true);
		onLoadListWaitingAddDevice();
		onLoadListActivities()
	}

	const onReloadSwapList = () => {
		onLoadListActivity('swapping');
	}

	const onReloadRemoveList = () => {
		onLoadListActivity('uninstallation');
	}

	const onReloadReinstallationList = () => {
		onLoadListActivity('reinstallation')
	}

	const onReloadServiceVisitList = () => {
		onLoadListActivity('serviceVisit')
	}

	const [tabSelected, setTabSelected] = useState(1);

	const handleChangeTab = (event, newValue) => {
		setTabSelected(newValue);
	};


	return (
		<HomeView
			fullName={fullName}
			showLoadingTotal={showLoadingTotal}
			total={total}
			activityTypes={activityTypes}
			stageId={stageId}
			stageCompletedId={stageCompletedId}
			message={message}
			showProcessing={showProcessing}
			isReloadCompletedList={isReloadCompletedList}
			setShowProcessing={setShowProcessing}
			showMessage={showMessage}
			onReloadInstallationList={onReloadInstallationList}
			onReloadSwapList={onReloadSwapList}
			onReloadRemoveList={onReloadRemoveList}
			onReloadReinstallationList={onReloadReinstallationList}
			onReloadServiceVisitList={onReloadServiceVisitList}
			tabSelected={tabSelected}
			handleChangeTab={handleChangeTab}
		/>
	)
}